import React from 'react';
import { useLocation } from 'react-router-dom';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { useT } from 'client/i18n/hooks/useT';
import serverRenderingUtils from 'helpers/serverRenderingUtils';
import { events } from 'client/screens/WordpressScreen/events';
import {
  clickSignupButton,
  clickedNavLinkGoogleAnalytics,
} from 'client/components/PublicWebsiteNav/events';

import {
  HomeHeroBackground,
  HomeHeroSection,
  HomeHeroTitleContainer,
  HomeHeroTitle,
  HomeHeroSubtitle,
  HomeHeroSignUpButton,
  HomeHeroSideImage,
  HomeHeroBottomLeftImage,
  HomeHeroBottomRightImage,
} from './styles';

export function HomeHero() {
  const t = useT();
  const { pathname } = useLocation();
  const isWpLandingPage = pathname.toLowerCase() === '/wordpressdotcom';

  return (
    <HomeHeroBackground>
      <HomeHeroSection data-value={serverRenderingUtils.getBaseUrl()}>
        <HomeHeroTitleContainer>
          <HomeHeroTitle>
            {t(
              'HomePage.HomeHero.Title',
              'Say it all with Anchor',
              'Anchor home page title'
            )}
          </HomeHeroTitle>
          <HomeHeroSubtitle>
            <h2>
              {t(
                'HomePage.HomeHero.Message',
                'Create, distribute, and monetize your podcast—all for free.',
                'Anchor home page message'
              )}
            </h2>
            <HomeHeroSignUpButton
              href={isWpLandingPage ? '/signup?ref=wp' : '/signup'}
              onClick={() => {
                clickSignupButton();
                clickedNavLinkGoogleAnalytics('Sign Up');
                if (isWpLandingPage) {
                  events.clickWordPressSignUpCTA('nav');
                }
              }}
            >
              {t(
                'HomePage.HomeHero.ButtonSignUp',
                'Get started',
                'Button to "Sign up"'
              )}
            </HomeHeroSignUpButton>
          </HomeHeroSubtitle>
        </HomeHeroTitleContainer>
        <HomeHeroSideImage>
          <MarketingImage
            width={351}
            height={589}
            imagePath="home/hero/hero-img-C1"
            alt={t(
              'HomePage.HomeHero.ImageAlt',
              'Photo of a person recording a podcast',
              'Home page image alternative'
            )}
          />
        </HomeHeroSideImage>

        <HomeHeroBottomLeftImage>
          <MarketingImage
            width={524}
            height={342}
            imagePath="home/hero/hero-img-C2"
            alt={t(
              'HomePage.HomeHero.ImageAlt',
              'Photo of a person recording a podcast',
              'Home page image alternative'
            )}
          />
        </HomeHeroBottomLeftImage>
        <HomeHeroBottomRightImage>
          <MarketingImage
            width={343}
            height={343}
            imagePath="home/hero/hero-img-C3"
            alt={t(
              'HomePage.HomeHero.ImageAlt',
              'Photo of a person recording a podcast',
              'Home page image alternative'
            )}
          />
        </HomeHeroBottomRightImage>
      </HomeHeroSection>
    </HomeHeroBackground>
  );
}
